import { cn } from '@/lib/utils';
import * as React from 'react';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'file:inline-flex bg-transparent disabled:bg-input/50 dark:bg-input/30 dark:disabled:bg-input/80 file:bg-transparent disabled:opacity-50 px-3 py-5 border border-input aria-invalid:border-destructive focus-visible:border-ring/30 dark:aria-invalid:border-destructive/50 file:border-0 rounded-lg outline-hidden aria-invalid:ring-3 aria-invalid:ring-destructive/20 focus-visible:ring-1 focus-visible:ring-ring/30 dark:aria-invalid:ring-destructive/40 w-full min-w-0 h-8 file:h-6 file:font-medium placeholder:text-muted-foreground file:text-foreground file:text-[length:var(--fs-subtitle)] text-[length:var(--fs-subtitle)] leading-[var(--lh-subtitle)] pointer-coarse:text-base transition-colors disabled:cursor-not-allowed disabled:pointer-events-none',
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export { Input };
